// Wrap player full names in article HTML with links to pdubfantasy.com profiles.
// Only replaces in text nodes — skips HTML tag attributes and existing <a> content.

export function linkifyPlayers(html, players) {
  if (!html || !players || players.length === 0) return html;

  const sorted = [...players]
    .filter(p => p.first_name && p.last_name && p.slug)
    .sort((a, b) => {
      const aLen = `${a.first_name} ${a.last_name}`.length;
      const bLen = `${b.first_name} ${b.last_name}`.length;
      return bLen - aLen;
    });

  if (sorted.length === 0) return html;

  // Tokenize into alternating [text, tag, text, tag, ...] segments
  const tokens = html.split(/(<[^>]*>)/);
  let insideAnchor = 0;

  return tokens
    .map(token => {
      if (token.startsWith('<')) {
        if (/^<a[\s>]/i.test(token)) insideAnchor++;
        else if (/^<\/a\s*>/i.test(token)) insideAnchor = Math.max(0, insideAnchor - 1);
        return token;
      }

      if (insideAnchor > 0) return token;

      let text = token;
      for (const player of sorted) {
        const fullName = `${player.first_name} ${player.last_name}`;
        const escaped = fullName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        // Unicode-aware boundary: not preceded/followed by a Unicode letter, digit, or hyphen
        const regex = new RegExp(`(?<![\\p{L}\\p{N}-])${escaped}(?![\\p{L}\\p{N}-])`, 'gu');
        text = text.replace(
          regex,
          `<a href="https://pdubfantasy.com/player/${player.slug}" target="_blank" rel="noopener noreferrer" style="color: #e91e8c; text-decoration: underline; font-weight: 600">${fullName}</a>`
        );
      }
      return text;
    })
    .join('');
}

// Convert plain text to minimal HTML: escape entities, wrap paragraphs, convert line breaks.
export function plainTextToHtml(text) {
  if (!text) return '';
  return '<p>' +
    text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/\n\n/g, '</p><p>')
      .replace(/\n/g, '<br/>') +
    '</p>';
}
